import React, { useCallback, useEffect, useState } from 'react';
import ScreenTextContext from './contexts/ScreenTextContext';
import { Play, SetUp, WrapUp } from './components/Screens';
import { api } from './utils/api';
import { MODE_SPECS } from './utils/constants';
import theme from './styles/MuiOverrides';
import { ThemeProvider } from '@material-ui/styles';


const screens = ["setup", "play", "wrapup"];

function App({ devSetUp }) {

  const [screenText, setScreenText] = useState({});

  const getScreenText = useCallback((language) => {
    api.getScreenTextForLanguage(language)
      .then((res) => {
        setScreenText(res.data);
      })
      .catch(err => {
        console.log(err)
      })
  }, [])
  
  const screenTextContextValue = { screenText, getScreenText };

  const [screen, setScreen] = useState(0);

  const [mode, setMode] = useState("");
  
  const [role, setRole] = useState("");
  
  const [teams, setTeams] = useState([]);
  const [initialTurn, setInitialTurn] = useState(0);
  
  const [categories, setCategories] = useState([]);
  const [lecture, setLecture] = useState([]);

  const [points, setPoints] = useState([]);
  const [scores, setScores] = useState([]);

  const [gameInProgress, setGameInProgress] = useState(false);

  const goToNextScreen = useCallback(() => {
    var nextScreen = screen + 1;

    // Go back to first screen if at the end.
    if (nextScreen >= screens.length) {
      nextScreen = 0
    }

    setScreen(nextScreen);
  }, [screen])

  const startGame = useCallback((mode, role, categories, lecture, teams, firstPlayer) => {
    setGameInProgress(true)

    // (language already done)

    // set the categories
    setCategories(categories);

    // set the role
    setRole(role);
    // lecture
    setLecture(lecture);

    // mode
    setMode(mode);

    // teams
    setTeams(teams);

    // turns
    setInitialTurn(firstPlayer);

    // move to the game screen
    goToNextScreen();
  }, [goToNextScreen])


  // Helper for development only:
  // Start game automatically with devSetUp, set in index.js
  useEffect(() => {

    if (devSetUp && !gameInProgress) {
      const { mode, role, categories, lecture, teams, firstPlayer, lang } = devSetUp;

      startGame(mode, role, categories, lecture, teams, firstPlayer);

      api.getScreenTextForLanguage(lang)
        .then((res) => {
          setScreenText(res.data);
        })
        .catch(err => {
          console.log(err)
        })
        
    }
  }, [devSetUp, gameInProgress, startGame])


  const completeGame = (scores) => {
    // array of points per team, i.e. index 0 holds points for team 0
    const points = [];

    // tally up the score based on point-value of questions
    // scores is a nested array, with inner arrays for teams and then for rounds
    // Example of scores from Meltdown mode:
    // [
    //   [ 
    //     [true, false, false, false, false, true, false], // round 0
    //     [true, false, false, false, true] // round 1
    //   ], // team 0
    //   [ 
    //     [false, true, false, false, true, false, true], // round 0
    //     [false, true, false, false, false] // round 1
    //   ], // team 1
    // ]
    scores.forEach(teamScores => {
      
      let tally = 0;

      teamScores.forEach((roundScores, roundIndex) => {
        const roundSpecs = MODE_SPECS[mode][roundIndex];

        roundScores.forEach(taskSuccess => {
          if (taskSuccess) {
            tally += roundSpecs.taskPointValue;
          }
        })
      })

      points.push(tally);

    })

    setScores(scores);
    setPoints(points);
    goToNextScreen();
  }

  const getGame = () => {
    return {
      categories,
      initialTurn,
      lecture,
      mode,
      role,
      scores,
      teams,
      screenText,
      completeGame,
      startGame,
    }
  }
    

  const getScreen = () => {
    switch(screens[screen]) {
      case "setup": 
        return <SetUp game={getGame()} />;
      case "play": 
        return <Play game={getGame()} />;
      case "wrapup":
        return <WrapUp game={getGame()} points={points} />
      default:
        return ""; // Should return error? Loading?
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <ScreenTextContext.Provider value={screenTextContextValue}>
        {getScreen()}
      </ScreenTextContext.Provider>
    </ThemeProvider>
  )

}

export default App;
